import Button from "@mlb/react-patterns/dist/components/Button/button";
import { Label } from "@mlb/react-patterns/dist/components/Button/button.style";
import { ButtonShapes, ButtonSizes, ButtonStyles } from "@mlb/react-patterns/dist/components/Button/button.types";
import COLORS from "@mlb/react-patterns/dist/style/universal.color";
import styled from "styled-components";
export var DragHandleContainer = styled(Button).attrs({
  shape: ButtonShapes.HOLLOW_BORDERLESS,
  size: ButtonSizes.LARGE,
  styleName: ButtonStyles.GREY
}).withConfig({
  displayName: "styles__DragHandleContainer",
  componentId: "sc-mz4vsu-0"
})(["align-items:center;background:none;display:flex;flex-direction:column;justify-content:center;padding:0 20px;user-select:none;&[data-focus-visible-added]{box-shadow:inset 0 0 0 3px rgba(0,137,255,0.65);outline:none;}&[disabled]{cursor:not-allowed;", " span{background:", ";}}&:hover:not([disabled]){background:none;cursor:", ";}", "{display:block;width:16px;span{display:block;background:", ";height:2px;margin-bottom:3px;transition:background 300ms ease-in-out;&:last-child{margin-bottom:0;}}}"], Label, COLORS.mlbGrey3, function (_ref) {
  var isGrabbing = _ref.isGrabbing;
  return isGrabbing ? "grabbing" : "grab";
}, Label, COLORS.mlbBlack);